import { render, staticRenderFns } from "./EditAttribute.vue?vue&type=template&id=cf91123e&scoped=true&"
import script from "./EditAttribute.vue?vue&type=script&lang=ts&"
export * from "./EditAttribute.vue?vue&type=script&lang=ts&"
import style0 from "./EditAttribute.vue?vue&type=style&index=0&id=cf91123e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf91123e",
  null
  
)

export default component.exports